module.exports = __webpack_public_path__ + "media/assets/facebook.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/facebook.svg
// module id = 29
// module chunks = 0